import {
	getAmounts,
	isLoanFutureType,
} from "web_myplann/Goals/Helpers/futureContractForm";
import { getDefaultFutureContractStartDate } from "web_myplann/Goals/Helpers/getDefaultFutureContractStartDate";
import type { PinFutureContractFormValues } from "web_myplann/Goals/Hooks/usePinFutureContractForm";
import {
	type FuturePortfolioCreateRequestDTO,
	type FuturePortfolioPartialUpdateRequestDTO,
	FuturePortfolioTypeEnum,
	type GoalFuturePortfolioResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { formatApiDate } from "web_myplann/Shared/Utils/dateFormatters";

export const getDefaultPinFutureContractValues =
	(): PinFutureContractFormValues => ({
		name: "",
		type: FuturePortfolioTypeEnum.Investment,
		monthly: 0,
		lumpSum: 0,
		loanAmount: 0,
		startDate: getDefaultFutureContractStartDate(),
		note: "",
	});

export const mapFuturePortfolioToFormValues = (
	editing: GoalFuturePortfolioResponseDTO | null | undefined,
): PinFutureContractFormValues => {
	if (!editing) {
		return getDefaultPinFutureContractValues();
	}

	const oneTime = editing.oneTimeDeposit ?? 0;
	const isLoan = isLoanFutureType(editing.type);

	return {
		name: editing.name,
		type: editing.type,
		monthly: editing.monthlyAmount ?? 0,
		lumpSum: isLoan ? 0 : oneTime,
		loanAmount: isLoan ? oneTime : 0,
		startDate: editing.startAt
			? new Date(editing.startAt)
			: getDefaultFutureContractStartDate(),
		note: editing.note ?? "",
	};
};

export const mapFutureContractFormToCreateRequest = (
	values: PinFutureContractFormValues,
	goalId: number,
): FuturePortfolioCreateRequestDTO => ({
	goalId,
	name: values.name.trim(),
	type: values.type,
	startAt: formatApiDate(values.startDate),
	note: values.note?.trim() || null,
	...getAmounts(values),
});

export const mapFutureContractFormToUpdateRequest = (
	values: PinFutureContractFormValues,
): FuturePortfolioPartialUpdateRequestDTO => ({
	name: values.name.trim(),
	type: values.type,
	startAt: formatApiDate(values.startDate),
	note: values.note?.trim() || null,
	...getAmounts(values),
});
